import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import {Drawer, DrawerContent, DrawerItem, DrawerNavigation} from '@progress/kendo-react-layout';
import {chevronDoubleLeftIcon, chevronDoubleRightIcon, menuIcon} from "@progress/kendo-svg-icons";
import {SvgIconButton} from "../../../base/Button/SvgIconButton.jsx";
import "./LeftNav.css";
import {GridContainerFlex} from "../../GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../../GridFlex/GridItemFlex/GridItemFlex.jsx";

export const LeftNav = ({ navLinks, children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [expanded, setExpanded] = useState(true);

    const handleToggle = () => {
        setExpanded(prevState => !prevState);
    };

    const handleSelect = (ev) => {

        // Navigate to the selected route
        const selectedItem = navLinks[ev.itemIndex];
        if (selectedItem && selectedItem.path) {
            navigate(selectedItem.path);
        }
    };

    return (
        <GridContainerFlex>
            <GridItemFlex xs={12}>
                <GridContainerFlex justifyContent={"start"}>
                    <GridItemFlex>
                        <SvgIconButton onClick={handleToggle} svgIcon={expanded ? chevronDoubleLeftIcon : chevronDoubleRightIcon} style={{marginLeft: 10}}/>
                    </GridItemFlex>
                </GridContainerFlex>
            </GridItemFlex>
            <GridItemFlex>
                <Drawer
                    expanded={expanded}
                    position="start"
                    mode="push"
                    animation={{ duration: 400 }}
                    onOverlayClick={handleToggle}
                    onSelect={(ev) => {
                        handleSelect(ev);
                    }}
                >
                    <DrawerNavigation>
                        <DrawerItem separator={true} />
                        {
                            ...navLinks.map((props, index) => (
                                <DrawerItem
                                    {...props}
                                    text={props.title}
                                    route={props.path}
                                    selected={location.pathname === props.path}
                                    onClick={() => handleSelect({...props, itemIndex: index})}
                                />
                            ))
                        }

                    </DrawerNavigation>
                    <DrawerContent className={"left-nav-content"}>
                        {children}
                    </DrawerContent>
                </Drawer>
            </GridItemFlex>
        </GridContainerFlex>
    );
};